import { client } from '../http';

export default {
  async getSimulatorInsights() {
    const response = await client.post('/api/insight-simulator');
    return response.data;
  },
};
